import React from "react";
import { IoMdColorFill } from "react-icons/io";
import COLORS from "scss/colors.module.scss";
import { observer } from "mobx-react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ColorPopup from "./Color/ColorPopup";
import { useContext } from "react";
import { ViewStoreContext } from "../ContainerStore";
import styled, { css } from "styled-components";
import { StyledTooltip } from "../../common/utils/StyledTooltip";
import { Badge } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ArrowDropDownCircleIcon from "@material-ui/icons/ArrowDropDownCircle";
import TabUnselectedIcon from "@material-ui/icons/TabUnselected";
import CallSplitIcon from "@material-ui/icons/CallSplit";

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -5,
    top: 3,
  },
}))(Badge);

function Color(props) {
  const viewStore = useContext(ViewStoreContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [colorPopupAnchorEl, setColorPopupAnchorEl] = React.useState(null);
  const [isColorPopupOpen, setIsColorPopupOpen] = React.useState(false);
  const [coloringType, setColoringType] = React.useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  let dropdownColumns = viewStore.columns.filter((col, index) => {
    return col.column_type_id === "3";
  });
  let colorCodes = Object.values(viewStore?.listConfig.colorCodes).flat();

  const isRowColoring =
    colorCodes.findIndex(
      (colorCode) => !colorCode.column_id || colorCode.column_id == "0"
    ) > -1;
  const isColumnColoring =
    colorCodes.findIndex(
      (colorCode) =>
        colorCode.column_id &&
        colorCode.column_id != "0" &&
        colorCode.is_dropdown_row_coloring == 0
    ) > -1;
  const isRowColoringBasedOnDropdown =
    colorCodes.findIndex(
      (colorCode) =>
        colorCode.column_id &&
        colorCode.column_id != "0" &&
        colorCode.is_dropdown_row_coloring == 1
    ) > -1;
  let tooltipTitle =
    "You can either use row coloring based on conditions or row coloring based on a dropdown field";

  return (
    <>
      <StyledColorButton
        highlighted={colorCodes.length > 0 ? true : false}
        className="d-flex"
        onClick={handleClick}
      >
        <IoMdColorFill size={18} color={COLORS.TEXT_COLOR} />
        <StyledColorTitle>Color</StyledColorTitle>
      </StyledColorButton>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        getContentAnchorEl={null}
        disableAutoFocusItem={true}
      >
        <StyledTooltip
          title={tooltipTitle}
          placement="right-start"
          disableHoverListener={!isRowColoringBasedOnDropdown}
        >
          <div>
            <MenuItem
              onClick={(e) => {
                setColorPopupAnchorEl(e.currentTarget);
                setIsColorPopupOpen(true);
                setColoringType("row");
              }}
              disabled={isRowColoringBasedOnDropdown}
            >
              <StyledCallSplitIcon />
              <StyledBadge
                variant="dot"
                invisible={!isRowColoring}
                color="secondary"
              >
                Row coloring based on conditions
              </StyledBadge>
            </MenuItem>
          </div>
        </StyledTooltip>
        <MenuItem
          onClick={(e) => {
            setColorPopupAnchorEl(e.currentTarget);
            setIsColorPopupOpen(true);
            setColoringType("column");
          }}
        >
          <StyledTabUnselectedIcon />
          <StyledBadge
            variant="dot"
            invisible={!isColumnColoring}
            color="secondary"
          >
            Cell coloring
          </StyledBadge>
        </MenuItem>
        <StyledTooltip
          title={tooltipTitle}
          placement="right-start"
          disableHoverListener={
            isRowColoring ? false : dropdownColumns.length > 0 ? true : false
          }
        >
          <div>
            <MenuItem
              disabled={
                isRowColoring ? true : dropdownColumns.length > 0 ? false : true
              }
              onClick={(e) => {
                setColorPopupAnchorEl(e.currentTarget);
                setIsColorPopupOpen(true);
                setColoringType("dropdown");
              }}
            >
              <StyledArrowDropDownCircleIcon />
              <StyledBadge
                variant="dot"
                invisible={!isRowColoringBasedOnDropdown}
                color="secondary"
              >
                Row coloring based on a dropdown-field
              </StyledBadge>
            </MenuItem>
          </div>
        </StyledTooltip>
      </Menu>
      <ColorPopup
        anchorEl={colorPopupAnchorEl}
        onClose={() => {
          setIsColorPopupOpen(false);
          handleClose();
        }}
        isOpen={isColorPopupOpen}
        coloringType={coloringType}
      />
    </>
  );
}

const StyledColorButton = styled.div`
  margin: 3px;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px;
  &:hover {
    background-color: ${COLORS.ACTIONS_HOVER};
  }
  ${(props) =>
    props.highlighted &&
    css`
      background-color: ${COLORS.GROUPED_FIELDS} !important;
      &:hover {
        box-shadow: inset 0px 0px 0px 2px ${COLORS.GROUPED_FIELDS_HOVER};
        box-sizing: border-box;
      }
    `};
`;

const StyledColorTitle = styled.div`
  color: ${COLORS.TEXT_COLOR};
  font-size: 12px;
  font-weight: 500;
  padding: 2px;
  padding-left: 5px;
`;

const StyledArrowDropDownCircleIcon = styled(ArrowDropDownCircleIcon)`
  margin-right: 5px;
  color: #212121 !important;
`;

const StyledTabUnselectedIcon = styled(TabUnselectedIcon)`
  margin-right: 5px;
  color: #212121 !important;
`;

const StyledCallSplitIcon = styled(CallSplitIcon)`
  margin-right: 5px;
  color: #212121 !important;
`;

export default observer(Color);
